import { render, staticRenderFns } from "./ComandosDeVozPainel.vue?vue&type=template&id=4e71a264&scoped=true"
import script from "./ComandosDeVozPainel.vue?vue&type=script&lang=js"
export * from "./ComandosDeVozPainel.vue?vue&type=script&lang=js"
import style0 from "./ComandosDeVozPainel.vue?vue&type=style&index=0&id=4e71a264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e71a264",
  null
  
)

export default component.exports